<template>
    <v-dialog
        v-model="display"
        persistent
        width="350"
        >
        <v-card>
            <v-card-title>{{ $t("DELETE_CONFIRM_TITLE") }}</v-card-title>
            <v-card-text>{{ $t("DELETE_CONFIRM_CONTENT") }}</v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    @click="submit"
                    :loading="loading"
                    :disabled="loading">    
                    {{ $t("DECISION_APPROVE") }}
                </v-btn>
                <v-btn
                    text
                    @click="close">
                    {{ $t("DECISION_REJECT") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DecisionDialog",
    data() {
        return {
            display: false,
            target: null,
            id: null,
            loading: false
        }
    },
    methods: {
        open(params) {
            this.target = params.target;
            this.id = params.id;
            this.display = true;
        },
        close() {
            this.display = false;
            this.target = null;
            this.id = null;
            this.loading = false;
        },
        submit() {
            this.loading = true;
            this.$emit("submit", {target: this.target, id: this.id});
        }
    },
    created() {
        
    }
}
</script>